angular.module('NiacsProjectApp.services-dialog',[
])
.controller('SafeConfirmDialogCtrl',['$scope','$uibModalInstance','contents',function($scope,$uibModalInstance,contents){
  $scope.contents = contents;
  if(contents.conditions) {
    contents.conditionsMet = contents.conditions.map(function(){ return false; });
  }
  $scope.allConditionsMet = function() {
    for(var i = 0; contents.conditionsMet && i < contents.conditionsMet.length; i++) {
      if(!contents.conditionsMet[i]) {
        return false;
      }
    }
    return true;
  };
  $scope.ok = function() { $uibModalInstance.close(); };
  $scope.cancel = function() { $uibModalInstance.dismiss(); };
}])
/**
 * Common service for supplying common functioning dialogs.  Currently there's
 * just one shared dialog (safe confirmation) but if in the future common behaving
 * dialogs come into existence they can be added here.
 */
.factory('DialogService',['$q','$uibModal',function($q,$uibModal){
  var service = {
    /**
     * Presents the user with a "safe confirmation" dialog.
     *
     * @param  {object} contents The dialog contents.
     *          noIcon: boolean (optional) - if specified will disable the heading icon.
     *          icon: string (optional) - font-awesome icon (minus the fa-).  If not specified defaults to 'exclamation-triangle'.
     *          iconSize: int (optional) - defaults to 3.
     *          message: string - The header message.
     *          warning: string (optional) - A warning message to place in the dialog body (e.g. 'This cannot be undone.')
     *          more: string (optional) - Some additional simple text to place in the dialog below the warning and above the conditions.
     *          conditions: array[string] (optional) - A list of conditions the user must indicate as understood before confirming.
     *          okText: string (optional) - Text for the ok button, defaults to 'OK'
     *          cancelText: string (optional) - Text for the cancel button, defaults to 'Cancel'
     *          windowClass: string (optional) - CSS class for the modal dialog window, defaults to 'safe-confirm-dialog'.
     *          type: char (optional) - ! or ? (default !).  Alters window class and main icon.
     * @return {promise}         A promise; resolved if OK, rejected if Cancel.
     */
    safe: function(contents) {
      var def = $q.defer();
      contents.type = contents.type||'!';
      contents.windowClass = (contents.windowClass||(contents.type == '?' ? 'safe-confirm-dialog-q' : 'safe-confirm-dialog'));
      contents.icon = (contents.icon||(contents.type === '?' ? 'question-circle' : 'exclamation-triangle'));
      $uibModal.open({
          templateUrl: 'partials/dialogs/safe-confirm-dialog.html',
          controller: 'SafeConfirmDialogCtrl',
          windowClass: contents.windowClass,
          backdrop: 'static',
          keyboard: false,
          resolve: {
              contents: function() { return contents; },
          }
      }).result.then(function(){
          def.resolve();
      },function(){
          def.reject();
      });
      return def.promise;
    }
  };
  return service;
}]);